import { FormSchema } from '@/forms/types/schema';

export type SendNotificationFieldValues = {
  notificationText: string;
};

const sendNotificationFormSchema: FormSchema<SendNotificationFieldValues> = {
  notificationText: {
    type: 'text',
    label: 'Notification text',
    value: '',
    validation: { required: true, maxLength: 1024 },
  },
};

export const buildSendNotificationFormSchema =
  (): FormSchema<SendNotificationFieldValues> => {
    const schema = sendNotificationFormSchema;
    return schema;
  };
